import { render, staticRenderFns } from "./articleDetail.vue?vue&type=template&id=387fb048&scoped=true"
import script from "./articleDetail.vue?vue&type=script&lang=js"
export * from "./articleDetail.vue?vue&type=script&lang=js"
import style0 from "./articleDetail.vue?vue&type=style&index=0&id=387fb048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387fb048",
  null
  
)

export default component.exports